module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters events-filter"
  }, [_c('dropdown-select', {
    staticClass: "field event-filter",
    attrs: {
      "options": _vm.manual_task_service_options
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.manual_task_service_filter),
      callback: function($$v) {
        _vm.manual_task_service_filter = $$v
      },
      expression: "manual_task_service_filter"
    }
  }), _c('date-range-picker', {
    ref: "date_range_picker",
    attrs: {
      "id": "date-picker-events",
      "full_period_option": true
    },
    on: {
      "date-changed": _vm.dateChanged
    }
  }), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44292f11!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/events/filters.vue
// module id = 1088
// module chunks = 1